import React, { Component } from 'react';
import User from './User';
import { Table, Button } from 'reactstrap';
import moment from 'moment';
import { AllowReturnTrip } from '../config/config'

export class BusReservationList extends Component {

    isHoliday = (baseDate) => {
        const { holidays } = this.props;
        const holidayDates = new Set(holidays.map(h => moment(h, 'YYYY-MM-DD').format('YYYY-MM-DD')));
        return holidayDates.has(baseDate.format('YYYY-MM-DD'));
    }

    addADaySkippingHolidays = (baseDate) => {
        let nextDay = baseDate.add(1, 'days');
        while (this.isHoliday(nextDay)) {
            nextDay.add(1, 'days');
        }
        return nextDay;
    }

    subtractADaySkippingHolidays = (baseDate) => {
        let prevDay = baseDate.clone().subtract(1, 'days');
        while (this.isHoliday(prevDay)) {
            prevDay = prevDay.clone().subtract(1, 'days');
        }
        return prevDay;
    }

    getReserveStartDate = (nowtime) => {
        let nowhour = nowtime.hour();
        let nowclone = nowtime.clone();
        let baseDate = this.addADaySkippingHolidays(nowtime);
        if (this.isHoliday(nowclone)) {
            baseDate = this.addADaySkippingHolidays(baseDate);
        }
        return baseDate;
    }

    renderBusReservations(reservations) {
        return (
            <div>
                <h4>バス予約情報</h4>
                <Table striped>
                    <thead>
                        <tr>
                            {AllowReturnTrip === 1 && (
                                <th>種別</th>
                            )}
                            <th>日付</th>
                            <th>路線</th>
                            <th>停留所</th>
                            <th>便</th>
                            <th>時間</th>
                            <th>変更された時間</th>
                            <th>予約メモ</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {reservations.map((item, index) => this.renderReservation(item, index))}
                    </tbody>
                </Table>
            </div>
        );
    }

    renderReservation(reservation, index) {
	const departureDate = moment(reservation.departureDate);
        const reserveStartDate = this.getReserveStartDate(moment());
        let isBeforeReserveStart = departureDate.isBefore(reserveStartDate, 'day');
        var enrouteDisplay = reservation.isReturn ? "帰り" : "行き";
	// 美池DSロジック：キャンセルボタンはずっと表示させる
	isBeforeReserveStart = false;

	// キャンセルロジックを実装。当日であれば2時間前までキャンセル可能
	// １０：２０前の便は前営業日の１８：３０まで、前営業日が土曜日の場合１７時までキャンセル可能
        const now = moment();
        const today = moment().format("YYYY-MM-DD");
        const lastBusinessDay = moment(this.subtractADaySkippingHolidays(moment(departureDate)));
        const tenThirty = moment(departureDate).startOf('day').add(10, 'hours').add(20, 'minutes');
        const seventeenHundred = moment().startOf('day').add(17, 'hours');
        const eighteenThirty = moment().startOf('day').add(18, 'hours').add(30, 'minutes');
        const isToday = moment(departureDate).format("YYYY-MM-DD") === today;
        const isLastBusinessDay = lastBusinessDay.format("YYYY-MM-DD") === today;
        const isLastBusinessDaySaturday = lastBusinessDay.day() === 6; // 6 = Saturday
	const isAfterLastBusinessDay = !isLastBusinessDay && lastBusinessDay.isBefore(moment());

        console.log("DepartureDate: ", departureDate.format("YYYY-MM-DD"));
        console.log("Today: ", today);
        console.log(isLastBusinessDay);
        console.log(isBeforeReserveStart);

	const dsDepartureDateTime = moment(`${moment(departureDate).format("YYYY-MM-DD")} ${reservation.dsDepartureTime}`);
        const departureDateTime = moment(`${moment(departureDate).format("YYYY-MM-DD")} ${reservation.departureTime}`, "YYYY-MM-DD HH:mm:ss");
        console.log("Now", now.format("MM/DD HH:mm:dd"));
        console.log("dsDepartureDateTime", dsDepartureDateTime.format("MM/DD HH:mm:dd"));
        console.log("departureDateTime", departureDateTime.format("MM/DD HH:mm:dd"));
        const isTooLate = (isToday && (dsDepartureDateTime.isBefore(tenThirty) || now.isAfter(dsDepartureDateTime.clone().subtract(2, 'hours')))) ||
                          (isLastBusinessDay && isLastBusinessDaySaturday && (now.clone().isAfter(seventeenHundred) && dsDepartureDateTime.clone().isBefore(tenThirty))) ||
                          (isLastBusinessDay && (now.clone().isAfter(eighteenThirty) && dsDepartureDateTime.clone().isBefore(tenThirty))) ||
		          (isAfterLastBusinessDay && dsDepartureDateTime.clone().isBefore(tenThirty));
	return (
            <tr key={index}>
                {AllowReturnTrip === 1 && (
                    <td>{enrouteDisplay}</td>
                )}
                <td>{departureDate.isValid() ? departureDate.format('YYYY-MM-DD') : 'Invalid Date'}</td>
                <td>{reservation.routeName}</td>
                <td>{reservation.stopName}</td>
                <td>{reservation.sequence}</td>
                <td>{reservation.departureTime}</td>
                <td>{reservation.changeTimeDisplay}</td>
                <td>{reservation.memo}</td>
                <td>
		    {!isBeforeReserveStart && (
		    <div>
                        <Button
                            color="danger"
                            onClick={() => this.handleCancel(reservation.stopId, reservation.departureDate, reservation.sequence)}
			    disabled={isTooLate}
                        >
                        キャンセル
                        </Button>
		    </div>
		)}
                </td>
            </tr>
        );
    }

    //render() {
    //    const { reservations } = this.props; // Get reservations from props
    //
    //    return (
    //        <div>
    //            {this.renderBusReservations(reservations)}
    //        </div>
    //    );
    //}

    render() {
        const { reservations } = this.props;

        // Sort by departure date and time
        const sortedReservations = [...reservations].sort((a, b) => {
            const dateA = moment(`${a.departureDate} ${a.departureTime}`, "YYYY-MM-DD HH:mm:ss");
            const dateB = moment(`${b.departureDate} ${b.departureTime}`, "YYYY-MM-DD HH:mm:ss");
            return dateA - dateB;
        });

        return (
            <div>
                {this.renderBusReservations(sortedReservations)}
            </div>
        );
    }

    async handleCancel(stopId, rsvdate, sequence) {
        const confirmCancel = window.confirm('この予約をキャンセルしてもよろしいですか？'); // Confirmation prompt
        if (!confirmCancel) return;

        try {
            var userNumber = User.getNumber();
            let formData = new FormData();
            formData.append("personNum", userNumber);
            formData.append("stopId", stopId);
            formData.append("rsvdate", rsvdate);
            formData.append("sequence", sequence);

            await fetch("busreservation/cancelbusride", {
                method: "POST",
                body: formData
            });

            this.props.refreshReservations(); // Refresh reservations after cancellation

            if (this.props.onCancelComplete) {
                this.props.onCancelComplete(); // Trigger the date validation in Bus.js
            }

        } catch (error) {
            console.error('Error occurred during cancellation', error);
        }
    }
}

